<template>
  <ul-dialog
    :visible.sync="dialogVisible"
    :title="title"
    width="800px"
    class="imgEdit"
    :close-on-click-modal="false"
    append-to-body
  >
    <vue-cropper
      v-if="dialogVisible"
      ref="cropper"
      :src="imgSrc"
      :aspectRatio="16 / aspec"
      :dragMode="'move'"
      :minContainerHeight="457"
    >
    </vue-cropper>
    <span slot="footer" class="dialog-footer">
      <ul-button type="primary" @click="saveImage">确定</ul-button>
      <ul-button plain @click="dialogVisible = false">取消</ul-button>
    </span>
  </ul-dialog>
</template>
<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { API_HOST, RESOURCE_SERVER_HOST } from "@/config";
import Obs from "@/plugins/ulearning-obs.js";
import { mapGetters } from "vuex";
import { setObsConfig } from '@/utils/file.js'
export default {
  name: "cropper",
  components: {
    VueCropper,
  },
  computed: {
    ...mapGetters({ token: "user/token" }),
  },
  data() {
    return {
      title: '上传封面',
      dialogVisible: false,
      imgSrc: '',
      aspec: 9
    };
  },
  methods: {
    uploadImg(e, info) {
      if (e.target.files.length == 0) {
        return
      }
      this.imgSrc = ''
      this.title = info.title
      this.aspec = info.fixedNumber || 9
      // 上传图片
      let file = e.target.files[0];

      // if (file.size > 2 * 1024 * 1024) {
      //   this.$message({
      //     message: `照片大小不超过2M!`,
      //     type: 'error'
      //   })
      //   return false;
      // }

      if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
        return this.$message({
          message: `照片类型必须是jpeg,jpg,png中的一种`,
          type: 'error'
        })
      }
      let reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.imgSrc = data;
        this.dialogVisible = true;
        this.$nextTick(()=>{
          this.setOptions(info)
        })
      };
      reader.readAsArrayBuffer(file);
    },
    setOptions(info) {
      console.log(this.$refs.cropper,'this.$refs.cropper');
      // this.$refs.cropper.setAspectRatio(1.77)
    },
    saveImage() {
      let self = this
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        let obs = new Obs(setObsConfig({
          uptokenHost: API_HOST,
          authorization: this.token,
          obsHost: RESOURCE_SERVER_HOST,
        }))
        blob.name = "resource/blob/" + Date.now() + '.png'
        blob.ext = '.png'
        obs.startUpload(blob)
        obs.onError = function (file,err) {
          console.log('error',file,err)
        }
        obs.onSuccess = function (file) {
          file.key = file.key.toLowerCase()
          let url = file.obsHost + '/' + file.key
          self.$emit('upData', url)
          console.log('success----',file, url)
          self.dialogVisible = false;
        }
        obs.onProgress = function (file,percent) {
          console.log('progress----',file, percent)
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.imgEdit {
  .ul-dialog__body {
    padding: 20px;
    >div {
      max-height: 457px;
    }
  }
}
</style>